import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource = '/operations/job_log/'
const reportResource = '/operations/job_log/report/'
const resultResource = '/operations/job_log/result/'
const tableResource = '/operations/job_log_table/'
const statusCountResource = '/operations/job_log/status_count/'

export default {
    get(){
        return Client.get(resource);
    },
    get(id){
        return Client.get(resource+'?id='+id);
    },
    getResult(id){
        return Client.get(resultResource+id+'/');
    },
    getJobGroupStatusCount(jobGroupLogId){
        return Client.get(`${statusCountResource}?job_group_log=${jobGroupLogId}`)
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    getTableWithJobGroupId(pageNumber,jobGroupId,filters){
        filters.page=pageNumber;
        filters.job_group_log=jobGroupId
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    getWithReportId(reportId){
        return Client.get(`${reportResource}?report_id=${reportId}`);
    },
    setReportId(jobHistoryId,reportId){
        return Client.put(`${resource}${jobHistoryId}/`,{report:reportId});
    }
}